import { useNavigate } from 'react-router-dom'

import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { Add } from '@factorialco/f0-react/icons/app'
import { LoadContentDocument } from 'generated/resources/graphql'

import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { graphqlContentMapper } from 'modules/trainings/lib/content/mappers'

import { contentRegistry } from './ContentRegistry'

export default function Syllabus({ trainingId }: { trainingId: number }) {
  const source = useGraphqlDataCollectionSource({
    document: LoadContentDocument,
    mapData: (data) => {
      return graphqlContentMapper
        .fromGraphQL(data.trainings.contentModules, Number(trainingId))
        .modules.flatMap((module) => {
          return module.blocks.map((block) => {
            return {
              moduleReference: `${module.uuid}:${module.title}:${module.blocks.length}`, // THIS IS CRAZY, I KNOW. But fetching the collection again to count groups is crazier.
              block,
            }
          })
        })
    },
    mapPagination: (data) => {
      return { total: data.trainings.contentModules.length, hasNextPage: false } // We're loading the whole thing at once.
    },
    mapVariables() {
      return {
        trainingId,
      }
    },
    paginationType: 'infinite-scroll', // This is a HACK to hide the bottom pagination. Since we load the whole thing at once, it should be fine.
    grouping: {
      hideSelector: true,
      collapsible: true,
      mandatory: true,
      defaultOpenGroups: true,
      groupBy: {
        moduleReference: {
          name: 'Module', // This is never shown, as it's the selector is hidden
          label(groupId) {
            return parseGroupId(groupId).title
          },
          itemCount(groupId) {
            return parseGroupId(groupId).count
          },
        },
      },
    },
  })

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <OneDataCollection
      emptyStates={{
        'no-data': {
          emoji: '🧩',
          title: i18n.t('trainings.content.empty.header'),
          description: i18n.t('trainings.content.empty.description'),
          actions: [
            {
              icon: Add,
              label: i18n.t('trainings.content.empty.button'),
              onClick: () => {
                navigate(
                  navigation.trainings.list.details_revamp.content.builder.fullPath({
                    id: trainingId,
                  })
                )
              },
              variant: 'outline',
            },
          ],
        },
      }}
      source={source}
      visualizations={[
        {
          type: 'list',
          options: {
            itemDefinition(item) {
              const description = contentRegistry.fetch(item.block, 'label')?.()
              const icon = contentRegistry.fetch(item.block, 'icon')

              return {
                title: String(item.block.title),
                description: description ? [description] : undefined,
                avatar: {
                  type: 'icon',
                  icon,
                  'aria-label': description,
                },
              }
            },
            fields: [
              //
              // TODO: In here we render the status for the employee. We need to figure out how does that work.
              // {
              //   label: 'Status',
              //   render(item) {
              //     return {
              //       type: 'alertTag',
              //       value: {
              //         level: 'success',
              //         label: 'completed'
              //       }
              //     }
              //   }
              // }
            ],
          },
        },
      ]}
    />
  )
}

function parseGroupId(groupId: unknown): {
  uuid: string
  title: string
  count: number
} {
  switch (typeof groupId) {
    case 'string': {
      const uuid = groupId.split(':')[0]
      const title = groupId.split(':')[1]
      const count = groupId.split(':')[2]

      return {
        uuid: String(uuid),
        title: String(title),
        count: Number(count),
      }
    }
    default: {
      throw 'Unknown groupId type'
    }
  }
}
